import { Divider, Stack, Typography } from "@mui/material";
import { RoleTableTabIcon, TableTabIcon } from "../../images";
import { ReactNode } from "react";

const Tab = ({
  children,
  isSelected,
  onChange,
}: {
  children: ReactNode;
  isSelected: boolean;
  onChange: () => void;
}) => {
  return (
    <Stack
      onClick={onChange}
      sx={{
        cursor: isSelected ? "auto" : "pointer",
        padding: "8px 14px",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: isSelected ? "#1C3C6C1A" : "transparent",
      }}
    >
      {children}
    </Stack>
  );
};
export const TabsBlock = ({
  currentTab,
  setCurrentTab,
}: {
  currentTab: string;
  setCurrentTab: (tab: string) => void;
}) => {
  const isRoleTab = currentTab === "role";

  return (
    <Stack gap="6px">
      <Typography variant="caption" color="custom.textDarkBlue">
        View
      </Typography>

      <Stack
        flexDirection="row"
        sx={{
          flexDirection: "row",
          border: "1px solid #EEEFEF",
          borderRadius: "6px",
          overflow: "hidden",
        }}
      >
        <Tab
          isSelected={isRoleTab}
          onChange={() => !isRoleTab && setCurrentTab("role")}
        >
          <RoleTableTabIcon color={isRoleTab ? "#1C3C6C" : undefined} />
        </Tab>
        <Divider orientation="vertical" flexItem sx={{ margin: 0 }} />
        <Tab
          isSelected={!isRoleTab}
          onChange={() => isRoleTab && setCurrentTab("table")}
        >
          <TableTabIcon color={isRoleTab ? undefined : "#1C3C6C"} />
        </Tab>
      </Stack>
    </Stack>
  );
};
